function t(e, n) {
  customElements.define(e, n);
}
export {
  t as d
};
//# sourceMappingURL=define-element-Dl91r6Vu.js.map
